
import { types } from "./types";
import SplitColumn from "./SplitColumn/SplitColumn";
import NormalizeMesaure from "./NormalizeMesaure/NormalizeMesaure";
import SortArray from "./SortArray/SortArray";
import FillEmpty from "./FillEmpty/FillEmpty";
import FilterRowsCells from "./FilterRowsCells/FilterRowsCells";




/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Actions(
    action,
    showAlert,
    variables,
    setOpenVariable,
    variableRender,
    automVersionId
) {
    switch (action.actionName) {
        case types.SPLITCOLUMN:
            return (
                <SplitColumn
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                />
            );
        case types.NORMALIZEMESAURE:
            return (
                <NormalizeMesaure
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                />
            );
        case types.SORTARRAY:
            return (
                <SortArray
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}

                />
            );
        case types.FILLEMPTY:
            return (
                <FillEmpty
                    action={action}
                    showAlert={showAlert}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automVersionId={automVersionId}

                />
            );
        case types.FILTERROWSCELL:
            return (
                <FilterRowsCells
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automVersionId={automVersionId}

                />
            );
        default: break;
    }
}

export default Actions;
